module.exports = __webpack_public_path__ + "img/JAPAN.45b819ed.png";